import { Box, Flex, Link } from "@chakra-ui/react";
import { useWindowSiteStore } from "@store/windowSiteStore";
import { scale } from "@utils/helpers";
import NextLink from "next/link";
import { useEffect, useState } from "react";
import { PaddedOnMobile } from "../layout";

type QuestionsSectionProps = {};

export const QuestionsSection = ({}: QuestionsSectionProps) => {
    const isDesktop = useWindowSiteStore((state) => state.isDesktop);
    const windowWidth = useWindowSiteStore((state) => state.windowWidth);

    const minSize = isDesktop ? 960 : 375;
    const maxSize = isDesktop ? 1200 : 960;

    return (
        <>
            <PaddedOnMobile>
                <Flex
                    direction="column"
                    w="100%"
                    maxW="370px"
                    justify="center"
                    align={isDesktop ? "center" : "start"}
                >
                    <Flex direction="column" align={isDesktop ? "center" : "start"}>
                        <Box
                            fontFamily="regular"
                            fontSize={scale(windowWidth, minSize, maxSize, 36, 48)}
                            lineHeight="110%"
                        >
                            Questions?
                        </Box>
                        <Box
                            pt={2}
                            pb={4}
                            fontSize={scale(windowWidth, minSize, maxSize, 18, 24)}
                            fontWeight="light"
                        >
                            <NextLink shallow href="mailto:br-support@beyondrarity.com" passHref>
                                <Link
                                    href="mailto:br-support@beyondrarity.com"
                                    textStyle="site.linkStyle"
                                    color="sorbet"
                                >
                                    Contact us here
                                </Link>
                            </NextLink>{" "}
                            so we can help.
                        </Box>
                    </Flex>
                </Flex>
            </PaddedOnMobile>
        </>
    );
};

export default QuestionsSection;
